module.exports = __webpack_public_path__ + "static/img/002.771b999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/002.jpg
// module id = AVkk
// module chunks = 1